import { SectionOfDashboard } from "./SectionOfDashboard";
import { SectionsToChart } from "./SectionsToChart";

export class DashboardTemplate {
  id?: string;
  dashboardTemplateName!: string;
  state!: boolean;
  sectionsOfDashboard!: Array<SectionOfDashboard>;
  sectionsToChart!: Array<SectionsToChart>;
}
